import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.country.label': {
    id: 'profile.country.label',
    defaultMessage: 'Location',
    description: 'The label for a country in a user profile.',
  },
  'profile.country.empty': {
    id: 'profile.country.empty',
    defaultMessage: 'Add location',
    description: 'The affordance to add country location to a user’s profile.',
  },
  'profile.country.option.default': {
    id: 'profile.country.option.default',
    defaultMessage: 'Select a country',
  },
  'profile.country.placeholder': {
    id: 'profile.country.placeholder',
    defaultMessage: 'Fill in the information about the country of your location',
  },
});

export default messages;
